import React, { useEffect, useRef } from 'react';
import { Animated } from 'react-native';
import {
  BusinessInfoCard,
  BusinessInfoCardProps,
} from '@/components/locations/business-info-card';
import { createStyles } from '@/contexts/theme-context';
import { shadow } from '@/styles';

export const FloatingBusinessInfoCard: React.FC<BusinessInfoCardProps> = ({
  ...props
}) => {
  const [styles] = useStyles();

  const cardAnimation = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.timing(cardAnimation, {
      duration: 200,
      toValue: props.business !== null ? 1 : 0,
      useNativeDriver: true,
    }).start();
  }, [cardAnimation, props.business]);

  return (
    <Animated.View
      style={[
        styles.card,
        {
          opacity: cardAnimation,
          transform: [
            {
              translateY: cardAnimation.interpolate({
                inputRange: [0, 1],
                outputRange: [100, 0],
              }),
            },
          ],
        },
      ]}
    >
      <BusinessInfoCard {...props} />
    </Animated.View>
  );
};

const useStyles = createStyles((theme) => ({
  card: {
    backgroundColor: theme.colors.background,
    borderRadius: 16,
    bottom: 48,
    left: 16,
    padding: 16,
    position: 'absolute',
    right: 16,
    ...shadow({
      color: theme.colors.black,
      elevation: 5,
      opacity: 0.1,
      radius: 4,
      x: 0,
      y: 4,
    }),
  },
}));
